import { createContext, useContext } from "react";
const FormFieldsContext = createContext(
  void 0
);
function useFormFields() {
  const context = useContext(FormFieldsContext);
  if (context === void 0) {
    throw new Error("useFormFields must be used within a FormFieldsProvider");
  }
  return context;
}
export {
  FormFieldsContext,
  useFormFields
};
//# sourceMappingURL=form-fields-context.js.map
